import React from "react";
import { RouterProvider } from "react-router-dom";
import { ToastProvider } from 'react-toast-notifications';
import { router } from "./routes/router";

function App() {
  return (
    <>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </>
  )
}

export default App;